export default __webpack_public_path__ + "static/2296-6f012ae62d85ae9a92822f19582a9515.gif";